import { Component, OnInit, Input } from '@angular/core';
import { DataService } from '../data.service';



@Component({
  selector: 'app-imageblock',
  templateUrl: './imageblock.component.html',
  styleUrls: ['./imageblock.component.css']
})
export class ImageblockComponent implements OnInit {
    public arrData = new Array<any>();
    public arrTable = new Array<any>();
    public arrTable1 = new Array<any>();
    @Input() webpagedefinitionitemid: number;
    @Input() docid: number;
    @Input() webpagelayoutitemid: number;
    @Input() webpagethemeelementid: number;
    @Input() cache: boolean;

    constructor(public dataservice: DataService) { }

    ngOnInit() {
        this.dataservice.getElementData(this.webpagedefinitionitemid, this.docid, this.webpagelayoutitemid, this.webpagethemeelementid, this.cache, 'g2/imageblock', (returndata: any) => {
            this.arrData = returndata;
            this.arrTable = returndata.Table;
            this.arrTable1 = returndata.Table1;
        }, '');

    } 

}
